import styled from "styled-components";

export const SideMain = styled.aside`
	width: 70px;
	background-image: linear-gradient(270deg, #364640 0%, #121212 130%);
	z-index: 100;

	position: fixed;
	height: 100vh;
	overflow-y: auto;
	overflow-x: hidden;
	top: 0;

	&:hover {
		width: 250px;
		> ul > li {
			justify-content: stretch;
			> img {
				margin: 0 auto;
			}
			a {
				display: flex;
				align-items: center;

				&:hover {
					color: #fff;
				}
			}
			svg {
				margin-left: 25px;
			}

			span {
				display: block;
				margin-left: 15px;
			}
		}
	}

	&::-webkit-scrollbar {
		width: 0;
	}

	> svg {
		margin-top: 0.5rem;
		padding: 0.2rem;
		cursor: pointer;
	}

	> ul {
		display: flex;
		flex-direction: column;
		height: 100%;
	}
`;

export const SideLogo = styled.li`
	width: 100%;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 12px;
	background-color: #121212;
	margin-bottom: 15px;
	> img {
		height: 46px;
	}
`;

export const SideItem = styled.li`
	width: 100%;
	height: 50px;
	color: white;
	cursor: pointer;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;

	> a {
		color: silver;
		display: contents;
		width: 100%;
		height: 100%;
		text-decoration: none;
	}

	&.logout {
		margin-top: auto;
	}

	&:hover {
		background-color: #121212;
		> svg {
			color: #fff;
		}
	}

	> svg {
		color: silver;
	}

	&.active-menu-item {
		background-color: #121212;
		svg,
		span {
			color: #fff;
		}
	}

	span {
		display: none;
	}
`;

export const Icon = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin: 5px 15px;
	> svg {
		cursor: pointer;
	}
`;
